import { Stack } from '@datanomik/commons-ui';

export const AreaHeader = ({ title }: { title: string }) => (
  <Stack sx={{
    padding: '8px 20px',
    textTransform: 'uppercase',
    fontSize: '12px',
    fontWeight: '500',
    backgroundColor: 'background.100',
    color: 'text.400',
  }}
  >
    {title}
  </Stack>
);
